module.exports = __webpack_public_path__ + "fonts/facDJg22.woff2";